{ logoDomain } = require '@trello/config'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('board_menu_invite_team')


module.exports = class BoardMenuInviteTeamComponent extends React.Component
  render: t.renderable ->
    { onClick, org, availableToInvite } = @props

    hash = org.get('logoHash')

    t.div '.invite-team', { onMouseDown: onClick }, ->
      if hash
        t.img '.team-logo', { src: "#{logoDomain}/#{hash}/170.png" }
      else
        t.span '.icon-lg.icon-organization.team-logo'
      t.div '.invite-team-text', ->
        t.p '.team-name', ->
          t.format 'add-all-of-team', { orgName: org.get('displayName') }
        t.p '.quiet', ->
          t.format 'x-team-members', { memberCount: availableToInvite.length }
